import styled from 'styled-components'

export const ProductDownloadRaisedBox = styled.div`
  ${({ theme }) => {
    return `
      background: ${theme.webMktNewPalette.white};
      box-shadow: 0px 16px 16px -8px ${theme.webMktNewPalette.alphaBlack[10]};
      padding: 24px 24px 48px 24px;
      box-sizing: border-box;
      width: 408px;
      z-index: 2;
      position: relative;

      ${theme.breakpoints.down('md')} {
        width: 100%;
      }

      .ProductDownload__Download-Eyebrow {
        text-transform: uppercase;
        margin: 0 0 24px 0;
        color: ${theme.webMktNewPalette.black};
      }

      .ProductDownload__Gray-Line {
        background: ${theme.webMktNewPalette.deepBlue[10]};
        width: 100%;
        height: 1px;
      }

      .ProductDownload__Download-Products {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        margin: 24px 0;
      }

      .ProductDownload__Download-Product-Logo {
        height: auto;
        margin-bottom: 8px;
        max-width: 140px;
        width: 100%;
      }

      .ProductDownload__Product-Description {
        color: ${theme.webMktNewPalette.deepBlue[55]};
      }

      .ProductDownload__Plus-Icon {
        width: 20px;
        height: 20px;
      }

      .ProductDownload__Download-Product-Item {
        width: 135px;
      }

      .ProductDownload__Download-Button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 16px;
        width: 100%;
        left: 24px;
        top: 218px;
        background: ${theme.webMktNewPalette.orange[50]};
        margin: 24px 0px;
        color: ${theme.webMktNewPalette.white};
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        box-sizing: border-box;
        justify-content: space-between;
      }

      .ProductDownload__Button-Icon {
        width: 22px;
        height: auto;
        max-height: 100%;
      }

      .ProductDownload__Disclaimer {
        color: ${theme.webMktNewPalette.deepBlue[55]};
        p {
          color: ${theme.webMktNewPalette.deepBlue[55]};
        }
      }

    `
  }}
`

export const ProductDownloadLogos = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 64px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    padding: 0 24px;
    box-sizing: border-box;
    margin-top: 32px;
  }

  .ProductDownload__Logos-Text {
    color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
    margin: 0;
  }

  .ProductDownload__Logos-Container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 16px;
    justify-content: space-between;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      margin: 0;
    }

    .ProductDownload__Customer-Logo-File {
      width: 60px;
      height: auto;
    }
  }
`
